
export const domain = process.env.REACT_APP_COGNITO_DOMAIN;
export const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

export const hostedUiBaseUrl =
  (process.env.REACT_APP_COGNITO_HOSTED_UI_BASE || (
    domain
      ? (domain.startsWith("http") ? domain.replace(/\/+$/, "") : `https://${domain}`)
      : ""
  ));

export const oauthScopes = (process.env.REACT_APP_COGNITO_OAUTH_SCOPES || "openid email profile aws.cognito.signin.user.admin")
  .split(/[,\s]+/)
  .filter(Boolean);

export const generateRedirectUri = () => {
  return window.location.origin;
};

export const redirectUri = generateRedirectUri();